<template>
  <div id="app-integration">
    <b-card
      v-if="value.status !== 1"
      class="mx-2 block-test-mode"
      no-body
    >
      <b-card-body style="padding: 0.857rem 1.214rem;">
        <div class="text-test-mode">
          <b-img
            :src="require('@/assets/images/icons/fi_info.svg')"
            style="position: absolute; transform: translate(0, -50%); top: 50%; left: 1.214rem; width: 1.214rem;"
          />
          <span style="display: inline-block; margin-left: 2.143rem; line-height: 130%;">
            {{ $t('apps.yourAppIsTestMode') }}
            <template v-if="value.status === 2">
              <br>{{ $t('apps.ourTeamIsReviewingYourIntegration') }}
            </template>
          </span>
        </div>
        <b-button
          v-if="value && value.status === 0"
          id="go-live-btn"
          :variant="btnGoliveVariant"
          @click="onClickRequestGolive"
        >
          {{ $t('apps.requestToGoLive') }}
        </b-button>
        <b-tooltip
          v-if="btnGoliveVariant === 'secondary'"
          target="go-live-btn"
          placement="bottom"
          triggers="hover"
        >
          {{ $t('apps.pleaseCompleteTheAppSetupFirst') }}
        </b-tooltip>
      </b-card-body>
    </b-card>
    <b-card class="mx-2 mb-2">
      <b-card-body>
        <div class="whitelisted-ips-panel">
          <h4 class="mb-50">
            {{ $t('apps.whitelistedIps') }}
          </h4>
          <p class="mb-1 text-muted">
            {{ $t('apps.changesTakeEffectAfter5Minutes') }}
          </p>

          <b-input-group
            v-for="(ip, index) in value.admin_ips"
            :key="`admin-ip-${index}`"
            class="mb-1"
          >
            <b-form-input
              v-model="value.admin_ips[index]"
              :placeholder="$t('apps.enterIpAddress')"
              @blur="normalizeWhitelistedIp(index)"
            />
            <b-input-group-append>
              <b-button
                variant="outline-danger"
                class="admin-ip-action-btn"
                @click="removeWhitelistedIp(index)"
              >
                -
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <b-button
            variant="outline-success"
            class="admin-ip-add-btn"
            @click="addWhitelistedIp"
          >
            {{ $t('apps.addIp') }}
          </b-button>

          <div
            v-if="whitelistedIpErrors.length > 0"
            class="mt-1"
          >
            <small
              v-for="(error, errorIndex) in whitelistedIpErrors"
              :key="`admin-ip-error-${errorIndex}`"
              class="text-danger d-block"
            >
              {{ error }}
            </small>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-tabs
      align="center"
      pills
      class="offer-type"
    >
      <b-tab>
        <template #title>
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                size="32"
                variant="light-primary"
              >
                <feather-icon
                  size="13"
                  icon="Share2Icon"
                  class="tab-title-icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <div class="tab-title-text">
                {{ $t('apps.apiIntegration') }}
              </div>
              <div
                class="tab-subtitle-text mb-0"
                style="height: 2.429rem"
              >
                {{ $t('apps.fetchSurveysGamesWithOurApi') }}
              </div>
            </b-media-body>
          </b-media>
        </template>
        <div class="detail-offer-wall">
          <div class="d-flex mb-1">
            <b-media no-body>
              <b-media-aside class="mr-1">
                <b-avatar
                  size="48"
                  variant="light-primary"
                >
                  <feather-icon
                    size="24"
                    icon="Share2Icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <div class="offer-info-block-title">
                  {{ $t('apps.integration') }}
                </div>
                <div
                  class="offer-info-block-des"
                  style="width: auto"
                >
                  {{ $t('apps.useOurApiToFetchDisplayAndManageSurveys') }}
                </div>
              </b-media-body>
            </b-media>
          </div>
          <hr style="border-top: 1px solid #EBE9F1; margin: 1.143rem 0 1.714rem;">
          <b-row>
            <b-col cols="12">
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="BookIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.documentation') }}
                        </div>
                        <p
                          class="offer-info-block-des"
                          style="width: auto"
                        >
                          <i18n
                            path="apps.documentationLinks"
                            tag="span"
                          >
                            <a
                              slot="offers"
                              target="_blank"
                              href="https://docs.primeearn.com/offers/api"
                            >{{ $t('apps.offersGames') }}</a>
                            <a
                              slot="surveys"
                              target="_blank"
                              href="https://docs.primeearn.com/surveys/api"
                            >{{ $t('apps.surveysDocumentation') }}</a>
                          </i18n>
                        </p>
                      </b-media-body>
                    </b-media>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="KeyIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.yourApiDetails') }}
                        </div>
                        <p
                          class="offer-info-block-des"
                          style="width: auto"
                        >
                          {{ $t('apps.theseAreTheCredentialsAndParametersYouNeedTo') }}
                        </p>
                      </b-media-body>
                    </b-media>
                    <div>
                      <div
                        class="d-flex align-items-center mb-50"
                        style="gap: 10px"
                      >
                        <strong>{{ $t('apps.apiBaseUrl') }}</strong>
                        <div class="code-copy-block">
                          <div
                            class="button-copy bg-primary"
                            @click="copyText(partnerApiUrl)"
                          >
                            <span>{{ $t('apps.copy') }}</span>
                          </div>
                          <div class="code-content bg-light-primary">
                            {{ partnerApiUrl }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block mb-50">
                          {{ $t('apps.contactYourAccountManagerForYourApiToken') }}
                        </small>
                      </div>
                      <div
                        class="d-flex align-items-center"
                        style="gap: 10px"
                      >
                        <strong>{{ $t('apps.appKey') }}</strong>
                        <div class="code-copy-block">
                          <div
                            class="button-copy bg-primary"
                            @click="copyText(`${app_hash}`)"
                          >
                            <span>{{ $t('apps.copy') }}</span>
                          </div>
                          <div class="code-content bg-light-primary">
                            {{ app_hash }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="HashIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.exampleApiRequest') }}
                        </div>
                      </b-media-body>
                    </b-media>
                    <div class="code-copy-block mt-2">
                      <div
                        class="button-copy bg-primary"
                        @click="copyText(`https://${partnerApiUrl}/api/surveys?output=API&app=${app_hash}&external_user_id=user-US-1&ip=35.151.72.180&gender=m&zip=32714&birthday=1992-02-19&user_agent=Mozilla%2F5.0 (Macintosh%3B Intel Mac OS X 10_15_7) AppleWebKit%2F537.36 (KHTML%2C like Gecko) Chrome%2F124.0.0.0 Safari%2F537.36&network=&source=&placement=`)"
                      >
                        <span>{{ $t('apps.copy') }}</span>
                      </div>
                      <div class="code-content bg-light-primary">
                        <pre class="code-block">
                            <span
                              class="hljs-string"
                              style="color: rgb(25 61 245);"
                            >https://{{ partnerApiUrl }}/api/surveys?output=</span><span
                          style="color: rgb(136, 0, 0);"
                        >API</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&app=</span><span
                          style="color: rgb(136, 0, 0);"
                        >{{ app_hash }}</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&external_user_id=</span><span
                          style="color: rgb(136, 0, 0);"
                        >user-US-1</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&ip=</span><span
                          style="color: rgb(136, 0, 0);"
                        >35.151.72.180</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&gender=</span><span
                          style="color: rgb(136, 0, 0);"
                        >m</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&zip=</span><span
                          style="color: rgb(136, 0, 0);"
                        >32714</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&birthday=</span><span
                          style="color: rgb(136, 0, 0);"
                        >1992-02-19</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&user_agent=</span><span
                          style="color: rgb(136, 0, 0);"
                        >Mozilla%2F5.0 (Macintosh%3B Intel Mac OS X 10_15_7) AppleWebKit%2F537.36 (KHTML%2C like Gecko) Chrome%2F124.0.0.0 Safari%2F537.36</span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&amp;network=&amp;source=&amp;placement=</span>
                        </pre>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab active>
        <template #title>
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                size="32"
                variant="light-primary"
              >
                <feather-icon
                  size="13"
                  icon="BookIcon"
                  class="tab-title-icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <div class="tab-title-text">
                {{ $t('apps.offerwall') }}
              </div>
              <div class="tab-subtitle-text mb-0">
                {{ $t('apps.userCanChooseAndCompleteMultipleSurveys') }}
              </div>
            </b-media-body>
            <div class="offer-type-recommend">
              {{ $t('apps.recommended') }}
            </div>
          </b-media>
        </template>
        <div class="detail-offer-wall">
          <div class="d-flex mb-1">
            <b-media no-body>
              <b-media-aside class="mr-1">
                <b-avatar
                  size="48"
                  variant="light-primary"
                >
                  <feather-icon
                    size="24"
                    icon="BookIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <div class="offer-info-block-title">
                  {{ $t('apps.offerwall') }}
                </div>
                <div class="offer-info-block-des">
                  {{ $t('apps.theOfferwallShowsMultipleSurveysToTheUserWho') }}
                </div>
              </b-media-body>
            </b-media>
          </div>
          <hr style="border-top: 1px solid #EBE9F1; margin: 1.143rem 0 1.714rem;">
          <b-row>
            <b-col cols="12">
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="BookIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.documentation') }}
                        </div>
                        <p
                          class="offer-info-block-des"
                          style="width: auto"
                        >
                          <i18n
                            path="apps.documentationLinks"
                            tag="span"
                          >
                            <a
                              slot="offers"
                              target="_blank"
                              href="https://docs.primeearn.com/offers/iframe"
                            >{{ $t('apps.offersGames') }}</a>
                            <a
                              slot="surveys"
                              target="_blank"
                              href="https://docs.primeearn.com/surveys/iframe"
                            >{{ $t('apps.surveysDocumentation') }}</a>
                          </i18n>
                        </p>
                      </b-media-body>
                    </b-media>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="8">
              <b-row class="mb-1">
                <b-col>
                  <div class="block-warning-unique-id">
                    <b-img
                      :src="require('@/assets/images/icons/fi_info.svg')"
                      style="position: absolute;transform: translate(0, -50%);top: 50%; left: 1.214rem; width: 1.214rem;"
                    />
                    <div style="display: inline-block; width: 30.643rem; margin-left: 2.143rem;">
                      <span style="font-weight: bold;">{{ $t('apps.uniqueUserIdToken') }}</span> {{ $t('apps.needsToBeReplacedByAUniqueUserId') }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row
                v-if="is_secure"
                class="mb-1"
              >
                <b-col>
                  <div class="block-warning-unique-id">
                    <b-img
                      :src="require('@/assets/images/icons/fi_info.svg')"
                      style="position: absolute;transform: translate(0, -50%);top: 50%; left: 1.214rem; width: 1.214rem;"
                    />
                    <div
                      style="display: block; width: 40.643rem; margin-left: 2.143rem; font-weight: bold; margin-bottom: 1rem"
                    >
                      {{ $t('apps.securityHashSalt', { value1: security_hash_salt }) }}
                    </div>
                    <div style="display: block; width: 40.643rem; margin-left: 2.143rem; margin-bottom: 1rem;">
                      {{ $t('apps.toCalculateThe') }} <span style="font-weight: bold;">{{ $t('apps.securityHashToken') }}</span>{{ $t('apps.pleaseUseTheFollowingFormula') }}
                    </div>
                    <div style="display: block; width: 30.643rem; margin-left: 2.143rem; font-weight: bold">
                      {{ $t('apps.md5UniqueUserIdSecurityHashSalt') }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="FramerIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.iframe') }}
                        </div>
                        <p class="offer-info-block-des">
                          {{ $t('apps.theIframeCanBeIntegratedToASeparatePage') }}
                        </p>
                      </b-media-body>
                    </b-media>

                    <div class="code-copy-block">
                      <div
                        class="button-copy bg-primary"
                        @click="copyText(integration_iframe)"
                      >
                        <span>{{ $t('apps.copy') }}</span>
                      </div>
                      <div class="code-content bg-light-primary">
                        <pre class="code-block"><span class="hljs-tag">&lt;<span
                          class="hljs-name"
                          style="font-weight: 700;"
                        >iframe</span> <span class="hljs-attr">src</span>=<span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >"{{ base_url }}/?app=<span style="color: rgb(136, 0, 0);">{{ app_hash }}</span>&amp;uuid=<span
                          style="color: rgb(136, 0, 0);"
                        >UNIQUE-USER-ID</span><span v-if="is_secure">&amp;shash=<span style="color: rgb(136, 0, 0);">SECURITY-HASH</span>
                        </span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&amp;network=&amp;source=&amp;placement=</span>"</span>&gt;</span><span class="hljs-tag">&lt;/<span
                          class="hljs-name"
                          style="font-weight: 700;"
                        >iframe</span>&gt;</span></pre>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="StarIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.surveysGamesOffersLink') }}
                        </div>
                        <p class="offer-info-block-des">
                          {{ $t('apps.combinedLinkForSurveysGamesAndOffersInOne') }}
                        </p>
                      </b-media-body>
                    </b-media>

                    <div class="code-copy-block">
                      <div
                        class="button-copy bg-primary"
                        @click="copyText(featured_url)"
                      >
                        <span>{{ $t('apps.copy') }}</span>
                      </div>
                      <div class="code-content bg-light-primary">
                        <pre class="code-block">
                          <span
                              class="hljs-string"
                              style="color: rgb(25 61 245);"
                          >{{ base_url }}/featured?app=</span><span
                            style="color: rgb(136, 0, 0);"
                        >{{ app_hash }}</span><span
                            class="hljs-string"
                            style="color: rgb(25 61 245);"
                        >&amp;uuid=</span><span
                            style="color: rgb(136, 0, 0);"
                        >UNIQUE-USER-ID</span><span
                            v-if="is_secure"
                        >&amp;shash=<span
                            style="color: rgb(136, 0, 0);"
                        >SECURITY-HASH</span></span><span
                          class="hljs-string"
                          style="color: rgb(25 61 245);"
                        >&amp;network=&amp;source=&amp;placement=</span>
                        </pre>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="LinkIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.surveysLink') }}
                        </div>
                        <p class="offer-info-block-des">
                          {{ $t('apps.thisLinkIsTheSameAsTheIframeYou') }}
                        </p>
                      </b-media-body>
                    </b-media>

                    <div class="code-copy-block">
                      <div
                        class="button-copy bg-primary"
                        @click="copyText(integration_url)"
                      >
                        <span>{{ $t('apps.copy') }}</span>
                      </div>
                      <div class="code-content bg-light-primary">
                        <pre class="code-block">
                                    <span
                                        class="hljs-string"
                                        style="color: rgb(25 61 245);"
                                    >{{ base_url }}/?app=<span
                                        style="color: rgb(136, 0, 0);"
                                    >{{ app_hash }}</span>&amp;uuid=<span
                                        style="color: rgb(136, 0, 0);"
                                    >UNIQUE-USER-ID</span><span
                                        v-if="is_secure"
                                    >&amp;shash=<span
                                        style="color: rgb(136, 0, 0);"
                                    >SECURITY-HASH</span></span><span
                                      class="hljs-string"
                                      style="color: rgb(25 61 245);"
                                    >&amp;network=&amp;source=&amp;placement=</span>
                                    </span>
                                    </pre>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <div
                    class="offer-info-block p-1"
                    style="border-left-width: 0.357rem !important;"
                  >
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar
                          size="32"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="16"
                            icon="ZapIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <div class="offer-info-block-title">
                          {{ $t('apps.gamesAndOffersLink') }}
                        </div>
                        <p class="offer-info-block-des">
                          {{ $t('apps.useThisLinkToSendUsersToGamesAnd') }}
                        </p>
                      </b-media-body>
                    </b-media>

                    <div class="code-copy-block">
                      <div
                        class="button-copy bg-primary"
                        @click="copyText(offers_url)"
                      >
                        <span>{{ $t('apps.copy') }}</span>
                      </div>
                      <div class="code-content bg-light-primary">
                        <pre class="code-block">
                          <span
                            class="hljs-string"
                            style="color: rgb(25 61 245);"
                          >{{ base_url }}/offers?app=</span><span
                            style="color: rgb(136, 0, 0);"
                          >{{ app_hash }}</span><span
                            class="hljs-string"
                            style="color: rgb(25 61 245);"
                          >&amp;uuid=</span><span
                            style="color: rgb(136, 0, 0);"
                          >UNIQUE-USER-ID</span><span
                            v-if="is_secure"
                          >&amp;shash=<span
                              style="color: rgb(136, 0, 0);"
                            >SECURITY-HASH</span></span><span
                              class="hljs-string"
                              style="color: rgb(25 61 245);"
                            >&amp;network=&amp;source=&amp;placement=</span>
                        </pre>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                <iframe
                  ref="designIframe"
                  style="
                    border: 1px solid #DBE1E6;
                    box-sizing: border-box;
                    border-radius: 4px;
                    transform-origin: top center;
                  "
                  frameborder="0"
                  :src="iframeUrlSurveys"
                  width="400px"
                  height="700px"
                  scrolling="no"
                />
              </div>
            </b-col>

          </b-row>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

/* eslint-disable no-useless-escape,no-useless-concat */
export default {
  name: 'AppEditIntegration',
  props: [
    'value',
    'iFrameUrlQuery',
  ],
  data() {
    return {
      integration_script: '',
      integration_iframe: '',
      integration_url: '',
      base_url: null,
      app_hash: null,
      is_secure: false,
      security_hash_salt: null,
      offers_url: '',
      featured_url: '',
      iframeUrlSurveys: '',
      whitelistedIpErrors: [],
    }
  },
  computed: {
    singleSurveyLinks() {
      return [
        {
          payout: 0.25,
          url: `${this.integration_url}&t=1`,
        },
        {
          payout: 0.50,
          url: `${this.integration_url}&t=2`,
        },
        {
          payout: 0.75,
          url: `${this.integration_url}&t=3`,
        },
        {
          payout: 1.00,
          url: `${this.integration_url}&t=4`,
        },
        {
          payout: 1.25,
          url: `${this.integration_url}&t=5`,
        },
        {
          payout: 1.50,
          url: `${this.integration_url}&t=6`,
        },
      ]
    },
    btnGoliveVariant() {
      let isValidReward = false
      if (this.value.reward_type !== 0) isValidReward = true
      else if (this.value.fixed_reward) isValidReward = true
      if (this.value.currency_exchange_rate && this.value.currency_name && isValidReward) return 'primary'
      return 'secondary'
    },
    iframeBaseUrl() {
      const SURVEY_BASE_URL = process.env.VUE_APP_SURVEY_BASE_URL

      return `${SURVEY_BASE_URL}/design-preview`
    },
    partnerApiUrl() {
      return 'partners.primeearn.com/{YOUR_API_TOKEN}'
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'value.is_secure': function (newValue) {
      this.is_secure = newValue
      this.updateUrls()
    },
    // eslint-disable-next-line func-names
    'value.security_hash_salt': function (newValue) {
      this.security_hash_salt = newValue
      this.updateUrls()
    },
    iFrameUrlQuery: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.iframeUrlSurveys = `${this.iframeBaseUrl}/surveys?${newVal}`
      },
    },
    'value.admin_ips': {
      deep: true,
      handler() {
        this.validateWhitelistedIps(false)
      },
    },
  },
  mounted() {
    window.AppEditIntegration = this
    this.app_hash = this.value.hash
    this.is_secure = this.value.is_secure
    this.security_hash_salt = this.value.security_hash_salt
    this.base_url = process.env.VUE_APP_SURVEY_BASE_URL
    this.ensureWhitelistedIpsArray()
    this.updateUrls()
  },
  methods: {
    requestToMakeAppLive() {
      this.showLoading()
      this.$http
        .post(`/api/app/${this.$route.params.appHash}/request-live`)
        .then(response => {
          const returnData = response.data
          if (returnData.status) {
            this.$emit('request-live', returnData.status)
            this.value.status = returnData.status
          }
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('apps.requestToGoLiveFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    onClickRequestGolive() {
      if (this.btnGoliveVariant !== 'secondary') {
        this.requestToMakeAppLive()
      }
    },
    ensureWhitelistedIpsArray() {
      if (Array.isArray(this.value.admin_ips)) {
        return
      }

      this.$set(this.value, 'admin_ips', [])
    },
    addWhitelistedIp() {
      this.ensureWhitelistedIpsArray()
      this.value.admin_ips.push('')
    },
    removeWhitelistedIp(index) {
      this.ensureWhitelistedIpsArray()
      this.value.admin_ips.splice(index, 1)
      this.validateWhitelistedIps()
    },
    normalizeWhitelistedIp(index) {
      this.ensureWhitelistedIpsArray()
      const value = this.value.admin_ips[index]
      this.$set(this.value.admin_ips, index, typeof value === 'string' ? value.trim() : '')
      this.validateWhitelistedIps()
    },
    isValidWhitelistedIp(value) {
      const rawValue = typeof value === 'string' ? value.trim() : ''
      if (!rawValue) {
        return false
      }

      const trimmedValue = rawValue.startsWith('[') && rawValue.endsWith(']')
        ? rawValue.slice(1, -1)
        : rawValue

      const ipv4Pattern = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/
      if (ipv4Pattern.test(trimmedValue)) {
        return true
      }

      try {
        const parsed = new URL(`http://[${trimmedValue}]`)
        const normalizedInput = parsed.hostname.toLowerCase()
        const reparsed = new URL(`http://${normalizedInput}`).hostname.toLowerCase()

        return normalizedInput === reparsed
      } catch (e) {
        return false
      }
    },
    validateWhitelistedIps(showErrors = true) {
      this.ensureWhitelistedIpsArray()
      const errors = []
      const uniqueIps = new Set()

      this.value.admin_ips.forEach((item, index) => {
        const currentIp = typeof item === 'string' ? item.trim() : ''

        if (!currentIp) {
          return
        }

        if (!this.isValidWhitelistedIp(currentIp)) {
          errors.push(i18n.t('apps.whitelistedIpIsNotAValidIpAddress', { value1: index + 1 }))
        }

        const normalizedIp = currentIp.toLowerCase()
        if (uniqueIps.has(normalizedIp)) {
          errors.push(i18n.t('apps.whitelistedIpIsDuplicated', { value1: index + 1 }))
        } else {
          uniqueIps.add(normalizedIp)
        }
      })

      if (showErrors) {
        this.whitelistedIpErrors = errors
      }

      return errors.length === 0
    },
    updateUrls() {
      const SURVEY_BASE_URL = this.base_url
      const optionalTrackingParameters = '&network=&source=&placement='

      if (!this.value.is_secure) {
        this.integration_url = `${SURVEY_BASE_URL}/?app=${this.value.hash}&uuid=UNIQUE-USER-ID${optionalTrackingParameters}`
        this.integration_script = `${'<script type="text/javascript">'
            + '{var primeSurveysConfig = {app: "'}${this.value.hash}", uuid: "UNIQUE-USER-ID"}}`
            + '<\/script>' + `\n<script src="${SURVEY_BASE_URL}/primewidget.js"/><\/script>`
        this.integration_iframe = `<iframe src="${SURVEY_BASE_URL}/?app=${this.value.hash}&uuid=UNIQUE-USER-ID${optionalTrackingParameters}"></iframe>`
        this.offers_url = `${SURVEY_BASE_URL}/offers?app=${this.value.hash}&uuid=UNIQUE-USER-ID${optionalTrackingParameters}`
        this.featured_url = `${SURVEY_BASE_URL}/featured?app=${this.value.hash}&uuid=UNIQUE-USER-ID${optionalTrackingParameters}`
        return
      }
      this.integration_url = `${SURVEY_BASE_URL}/?app=${this.value.hash}&uuid=UNIQUE-USER-ID&shash=SECURITY-HASH${optionalTrackingParameters}`
      this.integration_script = `${'<script type="text/javascript">'
          + '{var primeSurveysConfig = {app: "'}${this.value.hash}", uuid: "UNIQUE-USER-ID", shash: "SECURITY-HASH"}}`
          + '<\/script>' + `\n<script src="${SURVEY_BASE_URL}/primewidget.js"/><\/script>`
      this.integration_iframe = `<iframe src="${SURVEY_BASE_URL}/?app=${this.value.hash}&uuid=UNIQUE-USER-ID&shash=SECURITY-HASH${optionalTrackingParameters}"></iframe>`
      this.offers_url = `${SURVEY_BASE_URL}/offers?app=${this.value.hash}&uuid=UNIQUE-USER-ID&shash=SECURITY-HASH${optionalTrackingParameters}`
      this.featured_url = `${SURVEY_BASE_URL}/featured?app=${this.value.hash}&uuid=UNIQUE-USER-ID&shash=SECURITY-HASH${optionalTrackingParameters}`
    },
  },
}
</script>

<style scoped lang="scss">
#app-integration {
  .whitelisted-ips-panel {
    max-width: 820px;
  }

  .admin-ip-action-btn {
    min-width: 2.5rem;
    font-weight: 600;
  }

  .admin-ip-add-btn {
    min-width: 7.5rem;
    font-weight: 500;
  }

  .code-copy-block {
    position: relative;
    background: rgba(115, 103, 240, 0.12);
    border-radius: 0.429rem;
    overflow: hidden;

    & > .button-copy {
      width: 5.571rem;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      color: #FFF;
      text-align: center;
      cursor: pointer;

      span {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
    }

    & > .code-content {
      flex: 1;
      padding: 0.714rem;
      padding-left: 6.286rem;
    }
  }

  .code-block {
    display: block;
    white-space: initial;
    background: none;
    font-size: 1rem;
    margin-bottom: 0;
  }

  @media (max-width: 991px) {
    .whitelisted-ips-panel {
      max-width: 100%;
    }
  }
}

#app-integration .code-copy-block > .code-content > pre > span {
  display: inline !important;
}

.tab-title-text {
  font-style: normal;
  font-weight: 600;
  font-size: 1.143rem;
  line-height: 1.429rem;
}

.tab-subtitle-text {
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 120%;
  width: 18.929rem;
}

.offer-info-block {
  background: #F8F8F8;
  border-radius: 0.429rem;
}

.offer-info-block-title {
  font-weight: 600;
  font-size: 1.071rem;
  line-height: 1.286rem;
  color: #5E5873;
}

.offer-info-block-des {
  width: 35.357rem;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 120%;
  color: #6E6B7B;
}

.block-test-mode {
  background: rgba(234, 84, 85, 0.12);
  border-radius: 0.429rem;
  margin-bottom: 2.5rem;

  .text-test-mode {
    display: inline;
    margin-right: 2rem;
    font-weight: 500;
    font-size: 1rem;
    line-height: 120%;
    color: #EA5455
  }
}

.block-warning-unique-id {
  position: relative;
  background: rgba(234, 84, 85, 0.12);
  border-radius: 0.429rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 120%;
  color: #EA5455;
  padding: 0.857rem 1.214rem;
}

.offer-type-recommend {
  position: absolute;
  right: 0.714rem;
  color: #fff;
  top: -0.714rem;
  padding: 0.357rem 0.714rem;
  font-weight: 600;
  font-size: 0.857rem;
  line-height: 1.071rem;
  background: #6E6B7B;
  border-radius: 1.429rem;
}

.nav-link.active .offer-type-recommend {
  background: #7367F0;
}
</style>
<style>

[dir] .offer-type .nav-pills .nav-link {
  background: #FFFFFF;
  box-sizing: border-box;
  box-shadow: none;
  padding: 0.857rem;
  border-radius: 0.571rem;
}

[dir] .offer-type .nav-pills .nav-link.active {
  color: #7367F0;
  border: 1px solid #7367F0;
}

[dir] .offer-type.tabs .nav .nav-item {
  margin: 0 0.571rem !important;
  border-radius: 0.714rem !important;
}

svg.tab-title-icon {
  margin-right: 0 !important;
}

.offer-type .nav-link .tab-title-text {
  color: #6E6B7B;
}

.offer-type .nav-link.active .tab-title-text {
  color: #7367F0;
}
</style>
